import * as React from "react"
import { Menu, X } from "react-feather"
import {
  Container,
  Flex,
  FlexList,
  Space,
  NavLink,
  Button,
  InteractiveIcon,
  Nudge,
  VisuallyHidden,
} from "../ui"
import {
  mobileNavOverlay,
  mobileNavLink,
  desktopHeaderNavWrapper,
  mobileHeaderNavWrapper,
  mobileNavSVGColorWrapper,
} from "./header.css"
import NavItemGroup from "./nav-item-group"
import BrandLogo from "../brand-logo"
import scrollTo from 'gatsby-plugin-smoothscroll';
import {navlink} from "../ui.css";

export default function Header({isHeader}) {

  const [isOpen, setOpen] = React.useState(false)

  let cta = {
    text: 'Przejdź do Platformy',
    href: 'https://platforma.znajdzzastepstwo.pl/login'
  }

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden"
    } else {
      document.body.style.overflowY = "visible"
    }
  }, [isOpen])


  let navItems = [
    {
      "id": "a45bf3ae-6f44-5ef9-b081-d38fdde76ff8",
      "navItemType": "Scroll",
      "href": "#platforma",
      "text": "O nas"
    },
    {
      "id": "63f6b1bb-6887-5cc9-992f-316d6977793d",
      "navItemType": "Scroll",
      "href": "#funkcjonalnosci",
      "text": "Funkcjonalności"
    },
    {
      "id": "75affd84-e36a-50de-84ed-f19e8043317d",
      "navItemType": "Scroll",
      "href": "#kontakt",
      "text": "Kontakt"
    },
    {
      "id": "75affd84-e36a-50de-84ed-f19e8043317d",
      "navItemType": "Scroll",
      "href": "#demo-platformy",
      "text": "Zobacz demo"
    }
  ]

  return (
    <header className="header-ctn">
      <Container className={desktopHeaderNavWrapper}>
        <Space size={2} />
        <div className="hero-nav-ctn">
          <NavLink to="/" style={{display: 'flex', alignItems: 'center'}}>
            <BrandLogo />
          </NavLink>
          {isHeader &&
            <>
              <Flex gap={4}>
                <nav>
                  <FlexList gap={7}>
                    {navItems &&
                      navItems.map((navItem) => (
                        <li key={navItem.id}>
                          {navItem.navItemType === "Group" ? (
                            <NavItemGroup
                              name={navItem.name}
                              navItems={navItem.navItems}
                            />
                          ) : (
                            navItem.navItemType === "Scroll" ? (
                              <button
                                className={navlink}
                                onClick={() => scrollTo(navItem.href)}
                                style={{border: 'none', background: 'transparent', fontSize: '16px', cursor: "pointer", padding: 0}}
                              >
                                {navItem.text}
                              </button>
                            ) : (
                              <NavLink to="/umow-demo">
                                {navItem.text}
                              </NavLink>
                            )
                          )}
                        </li>
                      ))}
                  </FlexList>
                </nav>
              </Flex>
              <Flex>
                <div>{cta && <Button to="/umow-demo" variant="linkReversed">Umów spotkanie</Button>}</div>
                <div>{cta && <Button to={cta.href}>{cta.text}</Button>}</div>
              </Flex>
            </>
          }
        </div>
      </Container>
      <Container className={mobileHeaderNavWrapper[isOpen ? "open" : "closed"]}>
        <Space size={2} />
        <Flex variant="spaceBetween">
          <span
            style={{width: '80%'}}
            className={
              mobileNavSVGColorWrapper[isOpen ? "reversed" : "primary"]
            }
          >
          <NavLink to="/" style={{display: 'flex', alignItems: 'center'}}>
              <VisuallyHidden>Home</VisuallyHidden>
              <BrandLogo />
            </NavLink>
          </span>
          {
            isHeader &&
            (
              <>
                <Flex>
                  <Nudge right={3}>
                    <InteractiveIcon
                      title="Toggle menu"
                      onClick={() => setOpen(!isOpen)}
                      className={
                        mobileNavSVGColorWrapper[isOpen ? "reversed" : "primary"]
                      }
                    >
                      {isOpen ? <X /> : <Menu />}
                    </InteractiveIcon>
                  </Nudge>
                </Flex>
              </>
            )
          }
        </Flex>
      </Container>
      {isOpen && (
        <div className={mobileNavOverlay}>
          <nav>
            <FlexList responsive variant="stretch">
              {navItems?.map((navItem) => (
                <li key={navItem.id}>
                  {navItem.navItemType === "Group" ? (
                    <NavItemGroup
                      name={navItem.name}
                      navItems={navItem.navItems}
                    />
                  ) : (

                    navItem.navItemType === "Scroll" ? (
                      <button
                        className={mobileNavLink}
                        onClick={() => {scrollTo(navItem.href);setOpen(!isOpen);}}
                        style={{border: 'none', background: 'transparent', cursor: "pointer"}}
                      >
                        {navItem.text}
                      </button>
                    ) : (
                      <NavLink to="/umow-demo" className={mobileNavLink}>
                        {navItem.text}
                      </NavLink>
                    )
                  )}
                </li>
              ))}
            </FlexList>
          </nav>
        </div>
      )}
    </header>
  )
}
